import { render, staticRenderFns } from "./catalogControl.vue.js?vue&type=template&id=12196c1b&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalogControl.vue?vue&type=template&id=12196c1b&scoped=true"
import script from "./catalogControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalogControl.vue?vue&type=script&lang=js"
export * from "./catalogControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalogControl.vue?vue&type=script&lang=js"
import style0 from "./catalogControl.vue.scss?vue&type=style&index=0&id=12196c1b&prod&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalogControl.vue?vue&type=style&index=0&id=12196c1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12196c1b",
  null
  
)

export default component.exports